import buildSimpleStringFilter from '../buildSimpleStringFilter'

const InventoryTypeFilter = buildSimpleStringFilter({
  key: 'inventoryType',
  expandedOnInit: false,
})

export default InventoryTypeFilter
